import { isFedRamp } from '@atlassian/atl-context';

/**
 * This checks if the current environment is FedRamp and returns false.
 * The FF is just a fail safe to not change existing behaviour.
 */
export const isCMDBEnabledInEnvironment = () => !isFedRamp();
